import { isNull } from 'lodash/fp';
import { createPoller } from './createPoller';

export const createPollerActions = (
    task: $TSFixMe,
    interval: $TSFixMe,
    options = { startImmediately: true, progressive: false }
) => {
    let poller: $TSFixMe = null;
    const startPoller =
        (...args: $TSFixMe[]) =>
        (dispatch: $TSFixMe) => {
            if (isNull(poller)) {
                poller = createPoller(() => dispatch(task(...args)), interval, options);
            }

            if (!poller.isRunning()) {
                poller.start();
            }
        };

    const stopPoller = () => () => {
        if (!isNull(poller) && poller.isRunning()) {
            poller.stop();
        }
    };

    const destroyPoller = () => () => {
        stopPoller()();
        poller = null;
    };

    return [startPoller, stopPoller, destroyPoller];
};
